import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationTamil from './locales/tamil/translation.json';
import translationHindi from './locales/hindi/translation.json';
import translationKannada from './locales/kannada/translation.json';
import translationTelugu from './locales/telugu/translation.json';
import translationBengali from './locales/bengali/translation.json';

var options = {
    // order and from where user language should be detected
    order: ['path','localStorage'],
    // keys or params to lookup language from
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    // cache user language on
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    checkWhitelist: true
};

i18n
.use(LanguageDetector)
.init({
    debug: false,
    detection: options,
    whitelist: ["tamil", "hindi", "kannada", "telugu", "bengali"],
    interpolation: {
        escapeValue: false, // not needed for react
        formatSeparator: ","
    },

    resources: {
        tamil: {
            translations: translationTamil
        },
        hindi: {
            translations: translationHindi
        },
        kannada: {
            translations: translationKannada
        },
        telugu: {
            translations: translationTelugu
        },
        bengali: {
            translations: translationBengali
        }
    },
    // have a common namespace used around the full app

    ns: ["translations"],
    defaultNS: "translations"
});

export default i18n;